import { render, staticRenderFns } from "./ShortIcon.vue?vue&type=template&id=36fa5de4&"
import script from "./ShortIcon.vue?vue&type=script&lang=js&"
export * from "./ShortIcon.vue?vue&type=script&lang=js&"
import style0 from "./ShortIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports